import React from 'react';
import PropTypes from 'prop-types';
import Signature from './Signature';

const GroupItems = ({ group, items, type }) => (
    <div>
        <h3>{group}</h3>
        {items.map(item => (
            <Signature key={item.name} signature={item} link={`/${type}/${group}/${item.name}`} />
        ))}
    </div>
);

GroupItems.propTypes = {
    group: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    type: PropTypes.string.isRequired
}

export default GroupItems;



// WEBPACK FOOTER //
// ./src/GroupItems.js